module.exports = __webpack_public_path__ + "img/login-bg3.a89bee20.jpg";